export function getMeetingProvider(link) {
  if (!link) return 'upload'

  const googleMeetURLRegex = /^(https:\/\/)?meet\.google\.com\/(lookup\/)?[a-zA-Z0-9-?=&]+$/
  const zoomURLRegex = /^(https?:\/\/)?(zoom\.us|us\d+web\.zoom\.us)\/j\/\d{9,11}(\/?|\?\S+)$/
  const teamsURLRegex =
    /^https:\/\/(?:teams\.microsoft\.com\/(?:l\/meetup-join|meeting)\/|teams\.live\.com\/meet\/|teams\.microsoft\.us\/l\/meetup-join\/)[\w\-.~:/?#[\]@!$&'()*+,;=%]+$/i

  if (googleMeetURLRegex.test(link)) return 'google'
  if (zoomURLRegex.test(link)) return 'zoom'
  if (teamsURLRegex.test(link)) return 'teams'
  return 'upload'
}
